var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "booking-widget component" },
    [
      _vm._t("default", null, null, _vm.defaultScope),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-right" } }, [
        _vm.isActive
          ? _c(
              "div",
              {
                staticClass: "booking-widget-wrapper",
                class: [_vm.sidebarWidth],
                attrs: { role: "dialog" },
              },
              [
                _c(
                  "transition",
                  { attrs: { name: "fade", mode: "out-in" } },
                  [
                    _c(
                      _vm.currentPage,
                      _vm._b(
                        {
                          tag: "component",
                          on: {
                            "change-page": function ($event) {
                              _vm.currentPage = $event
                            },
                            "change-width": function ($event) {
                              _vm.sidebarWidth = $event
                            },
                            "change-login-component": function ($event) {
                              _vm.loginComponent = $event
                            },
                            back: function ($event) {
                              _vm.currentPage =
                                _vm.BOOKING_WIDGET_PAGES.CONFIRMATION
                            },
                            "auth-done": function ($event) {
                              _vm.currentPage =
                                _vm.BOOKING_WIDGET_PAGES.CONFIRMATION
                            },
                          },
                        },
                        "component",
                        _vm.bindings,
                        false
                      )
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.isActive
          ? _c("div", {
              staticClass: "backlight",
              on: { click: _vm.deactivate },
            })
          : _vm._e(),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }